import { UserDetails } from '../../common/models/user-details.model';

export class RequestBody {
    userName?: string;
}

export class NotificationsRequest extends RequestBody {
    notificationIds?: string[];
    userDetails?: UserDetails;

    setNotificationDetails(requestBody: RequestBody) {
        Object.assign(this, requestBody);
    }
}

export class Request {
    userDetails?: UserDetails;
}